import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "fonctionnalites",
  "data-model-id": "2:2955"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavSubsection = _resolveComponent("NavSubsection")!
  const _component_HeroSubsection = _resolveComponent("HeroSubsection")!
  const _component_IntroSubsection = _resolveComponent("IntroSubsection")!
  const _component_FeatureBlocksSubsection = _resolveComponent("FeatureBlocksSubsection")!
  const _component_FooterSubsection = _resolveComponent("FooterSubsection")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NavSubsection),
    _createVNode(_component_HeroSubsection),
    _createVNode(_component_IntroSubsection),
    _createVNode(_component_FeatureBlocksSubsection),
    _createVNode(_component_FooterSubsection)
  ]))
}